export default __webpack_public_path__ + "static/media/gg-erp.c3091563.png";